"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _enotaryActions = require("../actions/enotary-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  notarySession: {
    uuid: '',
    accessToken: '',
    documents: [// {
      //   notarySessionDocumentUuid: '',
      //   documentUuid: ''
      //   filename: '',
      //   type: '',
      //   participants: [
      //     {
      //       uuid: '',
      //       name: '',
      //       accepted: false // THIS IS SET HERE NOT PROVIDED BY SERVER
      //     }
      //     ...
      //   ],
      //   requirements: [
      //     {
      //       uuid: '',
      //       description: '',
      //       checked: false
      //     }
      //     ...
      //   ],
      //   accepted: false // THIS IS SET HERE NOT PROVIDED BY SERVER
      // }
    ],
    accepted: false,
    position: undefined
  },
  notaryHours: [],
  loading: false,
  error: ''
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.GET_POSITION, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    notarySession: _objectSpread(_objectSpread({}, state.notarySession), {}, {
      position: action.payload.position
    })
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.ORG_NOTARYHOURS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    notaryHours: action.payload
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.CONNECT, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.CONNECT, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    notarySession: _objectSpread(_objectSpread({}, state.notarySession), {}, {
      uuid: action.payload.uuid,
      accessToken: action.payload.accessToken,
      // TODO: determine if nested objects and arrays work in re-render land
      documents: (0, _util.mergeList)(state.notarySession.documents, action.payload.documents, 'notarySessionDocumentUuid'),
      accepted: action.payload.accepted
    }),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.CONNECT, "_").concat(_httpActions.FAILURE), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.ACCEPT, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var _action$meta = action.meta,
      documentUuid = _action$meta.documentUuid,
      notarySessionDocumentParticipantUuid = _action$meta.notarySessionDocumentParticipantUuid;
  var documents = state.notarySession.documents.map(function (d) {
    if (d.documentUuid === documentUuid) {
      var participants = d.participants.map(function (p) {
        if (p.uuid === notarySessionDocumentParticipantUuid) {
          return _objectSpread(_objectSpread({}, p), {}, {
            accepted: true
          });
        }

        return p;
      });
      return _objectSpread(_objectSpread({}, d), {}, {
        participants: participants,
        // a document is considered accepted relative to this co-deeder only
        accepted: participants.every(function (p) {
          return p.accepted;
        })
      });
    }

    return d;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    notarySession: _objectSpread(_objectSpread({}, state.notarySession), {}, {
      documents: documents,
      accepted: documents.every(function (d) {
        return d.accepted;
      })
    }),
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.ACCEPT, "_").concat(_httpActions.FAILURE), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_enotaryActions.CANCEL, "_").concat(_httpActions.REQUEST), _enotaryActions.DISCONNECT), function () {
  return _objectSpread({}, initialState);
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;